<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="computedDateFormattedMomentjs"
        label="Expiry date"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      :active-picker.sync="activePicker"
      :min="
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      "
      :max="
        new Date(
          new Date().setDate(new Date().getDate() + 365 * 2) -
            new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10)
      "
      @change="save"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";
// import Datepicker from "vuejs-datepicker";

export default {
  props: ["item", "errors"],
  components: {},
  data() {
    return {
      activePicker: null,
      date: null,
      menu: false,
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    date(val) {
      this.item.expire_at = this.computedDateFormattedMomentjs;
    },
    "item.expire_at"(val) {
      this.date = val ? moment(val).format("YYYY-MM-DD") : "";
    },
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.date ? moment(this.date).format("DD-MMM-YYYY") : "";
    },
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
      this.item.expire_at = this.computedDateFormattedMomentjs;
    },
  },
  mounted() {
    if (this.item && this.item.expire_at) {
      // this.date = this.item.expire_at.toString(); //new Date(this.item.expire_at).toString();
    }
  },
};
</script>